module.exports = __webpack_public_path__ + "static/4-c7f0cd6feba797ac78b6bd3aff2a7668.jpg";